export default {
  init: () => {
    document.querySelectorAll('.styled-form form').forEach((form) => {
      form.setAttribute('novalidate', true)
    })
  },
}
